import { useRef } from 'react'
import { ReactTags } from 'react-tag-autocomplete'
import { toast } from 'react-toastify'
import './ContentTagInput.css'

export const ContentTagInput = ({
    tags,
    placeholder,
    removeButtonText,
    suggestions,
    onChange,
}) => {
    
    const tagRef = useRef(null)
    
    const tagComponent = ({ tag, removeButtonText, onDelete }) => (
        <div className="react-tags__selected-tag" title={removeButtonText}>
            <div className="react-tags__selected-tag-name">{tag.name}</div>
            <button className="react-tags__selected-tag-action" onClick={onDelete}>&#x2715;</button>
        </div>
    )
    
    return (
        <div>
            <ReactTags
                ref={tagRef}
                selected={tags}
                suggestions={suggestions}
                allowResize={false}
                allowNew={true}
                allowBackspace={false}
                placeholderText={placeholder}
                deleteButtonText={removeButtonText}
                renderTag={tagComponent}
                onBlur={() => {
                    tagRef.current.clearInput()
                }}
                onAdd={async value => {
                    const tagsCopy = [...tags]
                    
                    tagsCopy.push(value)
                    onChange(tagsCopy)
                }}
                onDelete={async idx => {
                    const tagsCopy = [...tags]
                    
                    tagsCopy.splice(idx, 1)
                    onChange(tagsCopy)
                }}
                onValidate={tag => {
                    const nameExists = tags.some(t => t.name === tag.name)
                    
                    nameExists && toast.warn('Name has already been added')
                    return !nameExists
                }} />
        </div>
    )
}
